import { DocumentCategoryMetric } from 'features/libra/stepComponents/niiDataHealth/useDataHealthMetrics'
import { GeckoFileCategory } from 'types'

/**
 * Adds missing required categories with 0 count and sorts all metrics.
 *
 * Sorting order:
 * 1. Required categories first
 * 2. Then by count (descending)
 * 3. Then by label (alphabetically)
 */
export function sortAndAddMissingCategories(
  metrics: ReadonlyArray<DocumentCategoryMetric>,
  requiredCategories: ReadonlyArray<GeckoFileCategory>
): DocumentCategoryMetric[] {
  const existingCategories = new Set(metrics.map((m) => m.category))
  const missingRequired = requiredCategories
    .filter((cat) => !existingCategories.has(cat))
    .map((cat) => ({
      category: cat,
      categoryLabel: cat,
      count: 0,
      reportIds: [],
    }))

  return [...metrics, ...missingRequired].sort((a, b) => {
    // Required categories first
    const aRequired = requiredCategories.includes(a.category)
    const bRequired = requiredCategories.includes(b.category)
    if (aRequired && !bRequired) return -1
    if (!aRequired && bRequired) return 1

    // Then by count (descending)
    if (b.count !== a.count) {
      return b.count - a.count
    }

    // Then by label
    return a.categoryLabel.localeCompare(b.categoryLabel)
  })
}
